import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionlinecabbooking() {



const cardData = {
  keyword: " Pune to Mumbai Online Cab Booking  ",

"headingDescription": "SRS Cab Service offers Pune to Mumbai Online Cab Booking, providing a seamless, reliable, and comfortable travel experience from Pune to Mumbai. With easy online booking, professional drivers, and well-maintained vehicles, we ensure a hassle-free journey for business trips, airport transfers, and personal travel. Ideal for one-way or round trips, SRS Cab Service delivers transparent pricing, flexible booking options, and 24/7 customer support for a convenient and stress-free ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea. Travelers using Pune to Mumbai Online Cab Booking from SRS Cab Service often visit this historic site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a scenic promenade famous for its sunset views and city skyline. Visitors using SRS Cab Service often enjoy a relaxing walk along this coastal stretch."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for its cultural and historical significance."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station is renowned for its Victorian Gothic architecture. Visitors using SRS Cab Service often admire its architectural grandeur and heritage value."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a popular coastal destination known for street food and leisure activities. Travelers using SRS Cab Service often visit to enjoy the beach and sunset views."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a prominent temple dedicated to Lord Ganesha. Travelers using SRS Cab Service often visit to seek blessings and experience spiritual serenity."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque located on an islet in the Arabian Sea. Visitors using SRS Cab Service often visit for spiritual and scenic experiences."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping street in Mumbai. Travelers using SRS Cab Service often explore this area for shopping, dining, and cultural experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green space offering wildlife and trekking opportunities. Visitors using SRS Cab Service often enjoy outdoor activities and nature walks here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting key areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Pune to Mumbai Online Cab Booking Price",
description: "Pune to Mumbai online cab booking price provides estimated cost for easy travel planning. Customers can check prices before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Book your cab easily online."
},
{
name: "Pune to Mumbai Return Cab Fare",
description: "Pune to Mumbai return cab fare offers pricing details for round trip travel. Customers can plan return journeys easily. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with return cab services."
},
{
name: "Pune to Mumbai Taxi Fare",
description: "Pune to Mumbai taxi fare provides cost estimation for intercity travel. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Mumbai Affordable Fare",
description: "Pune to Mumbai affordable fare offers budget-friendly travel options for customers. Users can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable cab services."
},
{
name: "Pune Mumbai Online Innova Booking",
description: "Pune Mumbai online Innova booking provides premium SUV reservation options. Customers can book Innova for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Book your Innova easily online."
},
{
name: "Pune Mumbai Online Ertiga Booking",
description: "Pune Mumbai online Ertiga booking offers convenient 7 seater travel options. Customers can book vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your Ertiga easily online."
},
{
name: "Pune to Mumbai Sedan Cab Booking Online",
description: "Pune to Mumbai sedan cab booking online offers budget-friendly travel for individuals. Customers can book sedans instantly online. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your sedan easily online."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab provides comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab offers spacious SUV travel for comfort and convenience. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Pune Mumbai Online Innova Crysta Booking",
description: "Pune Mumbai online Innova Crysta booking provides luxury SUV travel options. Customers can book premium vehicles for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Book your Innova Crysta easily online."
},
{
name: "Toyota Innova Crysta Car Hire Pune",
description: "Toyota Innova Crysta car hire Pune offers premium vehicle rental for outstation travel. Customers can enjoy luxury seating and comfort. Professional drivers ensure safe journeys. Ideal for long-distance trips. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Toyota Innova Ertiga Car Booking",
description: "Toyota Innova Ertiga car booking provides flexible vehicle options for customers. Users can choose between Innova and Ertiga models. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your car easily."
},
{
name: "Pune to Mumbai Sedan Cab Service Online Booking",
description: "Pune to Mumbai sedan cab service online booking offers convenient travel options. Customers can book sedans instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Book your sedan easily online."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip provides convenient two-way travel solutions. Customers can book cabs for return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai offers top-rated transportation for intercity travel. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Pune to Mumbai 24x7 Online Cab Booking",
description: "Pune to Mumbai 24x7 online cab booking offers round-the-clock reservation for travel. Customers can book cabs anytime easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab anytime online."
},
{
name: "Pune to Mumbai Airport Cab Service",
description: "Pune to Mumbai airport cab service provides reliable transfer for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune Airport to Mumbai Cab",
description: "Pune airport to Mumbai cab offers direct travel for passengers. Customers can book cabs for convenient airport transfers. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Airport to Mumbai Airport Cab",
description: "Pune airport to Mumbai airport cab provides seamless transfer between airports. Customers can book cabs for quick travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune to Mumbai SRS Cab Service Online Cab Booking",
description: "Pune to Mumbai SRS cab service online cab booking offers reliable booking solutions. Customers can book cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
}
],

tableData: [
["Pune to Mumbai Online Cab Booking Price","Pune to Mumbai Return Cab Fare"],
["Pune to Mumbai Taxi Fare","Pune to Mumbai Affordable Fare"],
["Pune Mumbai Online Innova Booking","Pune Mumbai Online Ertiga Booking"],
["Pune to Mumbai Sedan Cab Booking Online","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune Mumbai Online Innova Crysta Booking"],
["Toyota Innova Crysta Car Hire Pune","Toyota Innova Ertiga Car Booking"],
["Pune to Mumbai Sedan Cab Service Online Booking","Pune to Mumbai Cab Round Trip"],
["Best Cab Service Pune to Mumbai","Pune to Mumbai 24x7 Online Cab Booking"],
["Pune to Mumbai Airport Cab Service","Pune Airport to Mumbai Cab"],
["Pune Airport to Mumbai Airport Cab","Pune to Mumbai SRS Cab Service Online Cab Booking"]
],



whychoose: [
  {
    WhyChooseheading: "Instant Pune to Mumbai Online Cab Booking",
    WhyChoosedescription: "SRS Cab Service offers quick and hassle-free Pune to Mumbai online cab booking with instant confirmation for smooth travel planning."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly Pune to Mumbai cab booking with clear fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai-Pune Expressway, ensuring safe, fast, and comfortable intercity travel."
  },
  {
    WhyChooseheading: "24/7 Online Booking Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7, allowing customers to book Pune to Mumbai cab anytime for airport transfers, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and relaxing journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your travel needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Drop Anywhere",
    WhyChoosedescription: "We offer pickup from any location in Pune and drop anywhere in Mumbai including airport, railway stations, and business hubs."
  },
  {
    WhyChooseheading: "Trusted Online Cab Booking Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mumbai online cab booking due to reliable service, punctual drivers, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "How can I book Pune to Mumbai cab online?", answer: "You can easily book Pune to Mumbai cab online through SRS Cab Service website or via phone booking." },
  { question: "Is Pune to Mumbai cab booking available 24 hours?", answer: "Yes, our online cab booking service operates 24/7." },
  { question: "What is the distance from Pune to Mumbai?", answer: "The distance between Pune and Mumbai is approximately 150 km and takes around 3 to 4 hours." },
  { question: "Which vehicles are available for booking?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book one-way cab online?", answer: "Yes, we provide both one-way and round-trip cab booking options." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Do I get instant booking confirmation?", answer: "Yes, customers receive instant confirmation after booking online." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from any location in Pune." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "Booked Pune to Mumbai cab online. Very easy process and quick pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Sharma",
    feedback:
      "Best online cab booking service. Comfortable ride and great experience.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mumbai Online Cab Booking | SRS Cab Service",
  "description": "Book Pune to Mumbai online cabs at affordable fares. Choose Innova, Ertiga, or Sedan for one-way or round trips, airport transfers, and city travel with 24x7 online booking.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-mumbai-online-cab-booking",
  "areaServed": ["Pune", "Mumbai", "Mumbai Airport", "Thane", "Vashi", "Kalyan"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Pune to Mumbai Online Cab Booking",
    "Pune to Mumbai Cab Fare",
    "Pune Mumbai Online Innova Booking",
    "Pune Mumbai Online Ertiga Booking",
    "Pune to Mumbai Sedan Cab Booking Online",
    "Pune to Mumbai Round Trip Cab",
    "Pune to Mumbai Airport Cab Service",
    "Pune Airport to Mumbai Cab"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1420"
  }
};










  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Online Cab Booking | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai online cabs with Innova, Ertiga, or Sedan at affordable fares. 24x7 booking for one-way, round trips, and airport transfers." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionlinecabbooking;